import React from 'react';
import Navigation from '../src/components/Navigation';

const PublicLayout = ({ children, onNavigate, currentPage, theme = 'light' }) => {
  if (theme === 'dark') {
    // Dark theme: Navigation overlays the content
    return (
      <div className="min-h-screen relative">
        <Navigation 
          onNavigate={onNavigate} 
          currentPage={currentPage}
          theme={theme}
        />
        <main className="relative">
          {children}
        </main>
      </div>
    );
  }
  
  // Light theme: Navigation sits above content (original behavior)
  return (
    <div className="min-h-screen">
      <Navigation 
        onNavigate={onNavigate} 
        currentPage={currentPage}
        theme={theme}
      />
      <main>
        {children}
      </main>
    </div>
  );
};

// layouts/AuthenticatedLayout.js  
const AuthenticatedLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Authenticated app navigation */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <div className="text-xl font-bold text-gray-800">Dashboard</div>
              <div className="hidden md:flex space-x-6">
                <a href="/overview" className="text-gray-600 hover:text-gray-900">Overview</a>
                <a href="/students" className="text-gray-600 hover:text-gray-900">Students</a>
                <a href="/courses" className="text-gray-600 hover:text-gray-900">Courses</a>
                <a href="/reports" className="text-gray-600 hover:text-gray-900">Reports</a>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button className="text-gray-600 hover:text-gray-900">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5m0-10h5l-5-5" />
                </svg>
              </button>
              <div className="w-8 h-8 bg-primary-500 rounded-full"></div>
            </div>
          </div>
        </div>
      </nav>
      
      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        {children}
      </main>
    </div>
  );
};

// layouts/CleanLayout.js
const CleanLayout = ({ children }) => {
  return (
    <div className="min-h-screen">
      {children}
    </div>
  );
};

export { PublicLayout, AuthenticatedLayout, CleanLayout };